'use client';

import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { createContext } from 'react';
import type { ShoppingFinishedPayload, SkuViewedPayload } from '../../Shibuya';

export interface AnalyticsSkuViewedContextValue {
  skuImpressionId: string;
  shoppingFinishedId: string;
  skuViewedPayload?: SkuViewedPayload;
  fireShoppingFinishedEvent: (props: AnalyticsShoppingFinishedCallbackProps) => void;
}

export interface AnalyticsShoppingFinishedCallbackProps {
  destinationUrl: ShoppingFinishedPayload['destination_url'];
  ctaType?: ShoppingFinishedPayload['cta_type'];
  finishType?: ShoppingFinishedPayload['finish_type'];
  revenueAmount?: ShoppingFinishedPayload['revenue_amount'];
  revenueType?: ShoppingFinishedPayload['revenue_type'];
  interstitialClientBotSuspected?: ShoppingFinishedPayload['interstitial_client_bot_suspected'];
  monetizable?: SkuViewedPayload['monetizable'];
  entryPointPageUrl?: SkuViewedPayload['entry_point_page_url'];
  estimatedRevenue?: ShoppingFinishedPayload['estimated_revenue'];
  overrideShoppingFinishedId?: ShoppingFinishedPayload['shopping_finish_id'];
}

export const AnalyticsSkuViewedContext = createContext<AnalyticsSkuViewedContextValue | null>(null);

export function useAnalyticsSkuViewedContext() {
  return useStrictContext(AnalyticsSkuViewedContext);
}
